// @flow
import Loadable from 'react-loadable';
import LoadableLoadingSection from 'components/LoadableLoadingSection';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "SearchPageContainer" */ '../containers/SearchPageContainer'),
  loading: LoadableLoadingSection
});
